import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

export interface IDate {
  key?: string;
  value?: string;
}

interface IDistributionStore {
  currentDate: IDate;
}

const initialState: IDistributionStore = {
  currentDate: {},
};

const currentDate: CaseReducer<IDistributionStore, PayloadAction<IDate>> = (state, action) => {
  state.currentDate = action.payload;
};

export const dateSlice = createSlice({
  name: 'OVP/date',
  initialState,
  reducers: {
    currentDate,
  },
});

const { currentDate: setCurrentDate } = dateSlice.actions;

export { setCurrentDate };
